import { useQuery } from '@tanstack/react-query'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'
import { useDebounce } from '@/frontend/hooks/use-debounce'

/** Searches patients and members with debounced input, scoped to the active region. */
export function useAppSearch(search: string) {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const debouncedSearch = useDebounce(search, 200)

  return useQuery({
    queryKey: ['app-search', debouncedSearch, region],
    queryFn: async () => {
      const response = await api.get('/search', { query: { q: debouncedSearch, region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    enabled: debouncedSearch.length >= 2,
  })
}
